/**
 * Constructs a URL query parameter string from an array of parameters
 * @param {string[]} params - Array of query parameter strings
 * @returns {string} Query string starting with '?' if params exist, empty string otherwise
 */

export const constructQueryParamString = (params: string[]) => {
  if (params.length === 0) return ''
  return `?${params.join('&')}`
}
